import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { Button } from 'AWS-UI-Components-React';
import { getCurrentStage } from '../../utilities';
import { DisplayIcon } from './display_icon'
import { AppSelector } from 'PIReactComponents';


import {
  PITOOLS_CONTACT_US_URL,
  PITOOLS_GETTING_STARTED_URL,
  SPOTLIGHT_GETTING_STARTED_URL
} from '../../constants/urls';
import FeatureTour from '../../components/feature_tour';
import {
  VIEW_CONTEXT,
  DISMISS_ACTIONS,
  STEP_FIELDS,
  RUN_TOUR_ON_PAGE_LOAD,
} from '../feature_tour/constants';
import { markItemAsDisplayed } from '../feature_tour/utils';

class NavigationMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      runTour: !!RUN_TOUR_ON_PAGE_LOAD,
    };
  }

  deriveViewContext = () => {
    const { location } = this.props;
    const { pathname } = location || {};
    const path = pathname ? pathname.replace(/\//g, '') : '';

    return path ? path : VIEW_CONTEXT.DEFAULT;
  };

  onClickNewFeaturesTour = () => {
    this.setState({
      runTour: true,
    });

    if (this.feautreTourHelpers) {
      const { reset } = this.feautreTourHelpers;
      reset(true);
    }
  };

  handleFeatureTourCallback = (data) => {
    const { action, step } = data;

    const itemId = step[STEP_FIELDS.FEATURE_TOUR_ID];
    markItemAsDisplayed(itemId);

    if (DISMISS_ACTIONS.includes(action)) {
      this.endTour();
    }
  };

  endTour = () => {
    if (this.feautreTourHelpers) {
      const { reset } = this.feautreTourHelpers;
      reset(true);
    }

    this.setState({
      runTour: false,
    });
  };

  setFeatureTourHelpers = (helpers) => {
    this.feautreTourHelpers = helpers;
  };

  deriveNewFeatureItemsToDisplay = (displayNewFeatureItems, viewContext, trackedEvents) => {
    return displayNewFeatureItems
      .filter((item) => [VIEW_CONTEXT.ALL, viewContext].includes(item.viewContext))
      .filter((item) => !item.trackedEvents || trackedEvents.some((e) => item.trackedEvents.includes(e)));
  };

  render() {
    const { displayNewFeatureItems, trackedEvents } = this.props;
    const { errorInFeatureTours } = this.state;
    const viewContext = this.deriveViewContext();
    const newFeatureItemsToDisplay = this.deriveNewFeatureItemsToDisplay(
      displayNewFeatureItems,
      viewContext,
      trackedEvents || []
    );
    const hasFeatureTourItems = newFeatureItemsToDisplay && newFeatureItemsToDisplay.length;

    return (
      <div className="navigation awsui-util-font-size-0">
        <div className="left">
          <ul id="h" className="menu-list">
            <DisplayIcon />
            <li className="selected">
              <NavLink exact to="/">
                Analytics
              </NavLink>
            </li>
            {this.props.featureList && this.props.featureList.includes('mapper') && [
              <li key="1" className="selected">
                {' '}
                |{' '}
              </li>,
              <li key="2" className="selected">
                <NavLink to={'/accuracy-mappings'}>Accuracy Mappings </NavLink>
              </li>,
            ]}
            {this.props.featureList && this.props.featureList.includes('spotlight') && [
              <li key="1" className="selected">
                {' '}
                |{' '}
              </li>,
              <li key="2" className="selected">
                <NavLink to={'/spotlight'}>SpotLight (Beta)</NavLink>
              </li>,
            ]}
            {this.props.featureList && this.props.featureList.includes('config-central') && [
              <li key="1" className="selected">
                {' '}
                |{' '}
              </li>,
              <li key="2" className="selected">
                <NavLink to={'/config-central'}>Config Central</NavLink>
              </li>,
            ]}
            {this.props.featureList && this.props.featureList.includes('simulator') && [
              <li key="1" className="selected">
                {' '}
                |{' '}
              </li>,
              <li key="2" className="selected">
                <NavLink to={'/simulator'}>Simulator</NavLink>
              </li>,
            ]}
            {this.props.featureList && this.props.featureList.includes('dashboard') && [
              <li key="1" className="selected">
                {' '}
                |{' '}
              </li>,
              <li key="2" className="selected">
                <NavLink to={'/dashboard'}>{getCurrentStage() === 'PROD' ? 'Usage Metrics' : 'Contra Cogs Bridging'}</NavLink>
              </li>,
            ]}
          </ul>
        </div>
        <div className="right">
          <div className="button-area">
            { hasFeatureTourItems && !errorInFeatureTours && (
              <Button variant="primary" onClick={this.onClickNewFeaturesTour}>
                New Features
              </Button>
            )}
            <a
              href={PITOOLS_CONTACT_US_URL}
              style={{ paddingRight: '1em', color:'white', paddingLeft: '1em' }}
              target="_blank">
              <b> Contact Us </b>
            </a>
            <a
              href={window.location.href.includes('spotlight') ? SPOTLIGHT_GETTING_STARTED_URL : PITOOLS_GETTING_STARTED_URL}
              target="_blank"
              style={{ paddingRight: '1em', color:'white' }}
            >
              <b> Getting Started </b>
            </a>
            <AppSelector stage={getCurrentStage().toLowerCase()} />
          </div>
        </div>
        {!!hasFeatureTourItems && !errorInFeatureTours && (
          <FeatureTour
            runTour={this.state.runTour}
            handleError={(err) => {
              this.setState({ errorInFeatureTours: true });
            }}
            handleFeatureTourCallback={this.handleFeatureTourCallback}
            displayNewFeatureItems={newFeatureItemsToDisplay}
            getHelpers={this.setFeatureTourHelpers}
          />
        )}
      </div>
    );
  }
}

export default withRouter(NavigationMenu);



// WEBPACK FOOTER //
// ./src/components/navigation/navigation_menu.jsx